export const actions = {
    devLog({ getters }, data) {
        if (getters.showDevInfo) {
            console.log(...data);
        }
    }
};
